"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _redux = require("../redux"); // import app components


var LanguageSwitcher = function LanguageSwitcher() {
  var _site$languages, _site$languages$langu;

  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      _ref$cms = _ref.cms,
      site = _ref$cms.site,
      activeLanguage = _ref$cms.activeLanguage;

  var dispatch = (0, _redux.useAppDispatch)();
  return /*#__PURE__*/_react.default.createElement(_antd.Select, {
    value: activeLanguage,
    onChange: function onChange(v) {
      return dispatch(_redux.cmsActions.setActiveLanguage(v));
    },
    style: {
      width: '100px'
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: "all"
  }, "All"), site === null || site === void 0 ? void 0 : (_site$languages = site.languages) === null || _site$languages === void 0 ? void 0 : (_site$languages$langu = _site$languages.languages) === null || _site$languages$langu === void 0 ? void 0 : _site$languages$langu.map(function (o) {
    return /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      key: o.id,
      value: o.slug
    }, o.name);
  }));
};

var _default = LanguageSwitcher;
exports.default = _default;